import {api, API_URL} from "../config/apiConfig";
import { handleUnauthorizedOrForbidden } from "../config/varConfig";

// Get all recharge offers
export const getRechargeOffer = async () => {
  try {
    const response = await api.get(`${API_URL}/recharge_offers`);
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Important: re-throw the error
  }
};

// Add new recharge offer
// export const addRechargeOffer = async (rechargeOffer) => {
//   try {
//     const response = await api.post(`${API_URL}/recharge_offers`, rechargeOffer, {
//       headers: { // Fixed: header -> headers
//         "Content-Type": "multipart/form-data"
//       },
//     });
//     return response.data;
//   } catch (error) {
//     handleUnauthorizedOrForbidden(error);
//     throw error; // Important: re-throw the error
//   }
// };

// export const addRechargeOffer = async (rechargeOffer) => {
//   try {
//     const response = await api.post(`${API_URL}/recharge_offers`, rechargeOffer, {
//       headers: {
//         "Content-Type": "application/json", // Changed from multipart/form-data to application/json
//       },
//     });
//     return response.data;
//   } catch (error) {
//     handleUnauthorizedOrForbidden(error);
//     throw error;
//   }
// };


// Add new recharge offer
export const addRechargeOffer = async (rechargeOffer) => {
  try {
    const response = await api.post(`${API_URL}/recharge_offers`, rechargeOffer, {
      headers: {
        "Content-Type": "application/json", // ✅ JSON format
      },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Update recharge offer - FIXED FUNCTION NAME
// export const updateRechargeOffer = async (id, rechargeOffer) => { // Fixed: udateRechargeOffer -> updateRechargeOffer
//   try {
//     const response = await api.put(`${API_URL}/recharge_offers/${id}`, rechargeOffer, { // Fixed: removed hardcoded ID
//       headers: {
//         "Content-Type": "multipart/form-data",
//       },
//     });
//     return response.data;
//   } catch (error) {
//     handleUnauthorizedOrForbidden(error);
//     throw error; // Important: re-throw the error
//   }
// };

export const updateRechargeOffer = async (id, rechargeOffer) => {
  try {
    const response = await api.put(`${API_URL}/recharge_offers/${id}`, rechargeOffer, {
      headers: {
        "Content-Type": "application/json", // ✅ JSON format
      },
    });
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error;
  }
};

// Delete recharge offer
export const deleteRechargeOffer = async (id) => {
  try {
    const response = await api.delete(`${API_URL}/recharge_offers/${id}`); // Fixed: removed hardcoded ID
    return response.data;
  } catch (error) {
    handleUnauthorizedOrForbidden(error);
    throw error; // Important: re-throw the error
  }
};